"use client";
import MonarchResolver from "@/monarch/MonarchResolver";
import type { ProductCardRedesignTestResult } from "@/monarch/rules/productCardRedesign/types";
import { ProductCardProps } from "../types";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import { ClientSideProductCard } from "..";
import { ClientSideNewProductCard } from "../../NewProductCard";
import { Skeleton } from "@/components/ui/skeleton";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";

export default function ProductCardWrapper(props: ProductCardProps) {
  return (
    <ClientOnly>
      <MonarchResolver<ProductCardRedesignTestResult>
        experimentKey="useProductCardRedesign"
        variants={{
          control: <ClientSideProductCard {...props} />,
          test: (
            <MonarchDataConsumer<ProductCardRedesignTestResult>
              experimentKey="useProductCardRedesign"
              render={(testResult) => {
                const enhancedProps = {
                  ...props,
                  productCardType: {
                    singleCourseTags: testResult.data?.singleCourseTags,
                    programTags: testResult.data?.programTags,
                    execEdTags: testResult.data?.execEdTags,
                    degreeTags: testResult.data?.degreeTags,
                  },
                  showBadges: testResult.data?.showBadges || false,
                  badges: testResult.data?.badges || [],
                  badgesByProduct: testResult.data?.badgesByProduct || [],
                  showCtaFooter: testResult.data?.showCtaFooter || false,
                  cta: testResult.data?.cta,
                  hoverEffect: testResult.data?.hoverEffect,
                  popularItemList: testResult.data?.popularItemList || [],
                  microDegreeTag: testResult.data?.microDegreeTag,
                  hoverDataControl: testResult.data?.hoverDataControl,
                  hoverEffectCta: testResult.data?.hoverEffectCta,
                  popularBadgeOverride: testResult.data?.popularBadgeOverride,
                };

                return <ClientSideNewProductCard {...enhancedProps} />;
              }}
            />
          ),
        }}
        fallbackVariant="control"
        Loader={<Skeleton variant="productCard" className="rounded-xl" />}
      />
    </ClientOnly>
  );
}
